import React, { useEffect, useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMusic } from '../context/MusicContext'

const ArtistList = () => {
  const { artists, setArtists, API_URL } = useMusic()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)

  const fetchArtists = useCallback(async () => {
    console.log(
      `Fetching artists from  fetch Artists at${new Date().toISOString()}:`,
      API_URL,
    )
    try {
      setIsLoading(true)
      const response = await fetch(`${API_URL}/artists`)
      console.log(
        `Recieved data from fetchArtists at ${new Date().toISOString()}:`,
        API_URL,
      )
      const data = await response.json()
      console.log('ArtistList data', data)
      // const filteredData = data.filter((artist) => {
      //   return artist.name.toLowerCase() !== 'övriga'
      // })
      setArtists(Array.isArray(data) ? data : [])
    } catch (error) {
      console.error('Failed to fetch artists:', error)
      setArtists([])
    } finally {
      setIsLoading(false)
    }
  }, [API_URL])

  useEffect(() => {
    fetchArtists()
  }, [fetchArtists])

  return (
    <>
      {isLoading && (
        <div className="page-status" role="status" aria-live="polite">
          Laddar artister...
        </div>
      )}
      {!isLoading && artists.length === 0 && (
        <div className="page-status" role="status">
          Inga artister hittades.
        </div>
      )}
      <div className="artist-grid">
        {artists.map((artist, index) => (
          <div
            key={index}
            className="artist-card"
            onClick={() => navigate(`/artist/${artist.name}`)}
          >
            <img
              src={`${API_URL}/artist/${artist.name}/cover/cover`}
              alt={artist.name}
              className="artist-image"
            />
            <h3>{artist.name}</h3>
          </div>
        ))}
      </div>
    </>
  )
}

export default ArtistList
